import { FeatheredImage } from "../../FeatheredImage";

const A = "/brand";

const WEIGHT_IMG = `${A}/blueprint4joy-visionbook-weighttransformation.jpg`;
const WEIGHT_ALT = "A Vision Book spread about a personal transformation goal, with collaged words like 'Wanted,' 'Take It Off' and 'The Ultimate Body.'";

function SpreadImage({ src, alt, testId, aspect, className = "" }) {
  return (
    <div className={className}>
      <div className="relative w-full" style={{ aspectRatio: aspect }}>
        <FeatheredImage
          src={src}
          alt={alt}
          testId={testId}
          objectPosition="center"
          featherLeft={10}
          featherRight={10}
          featherTop={10}
          featherBottom={10}
          className="absolute inset-0"
        />
      </div>
    </div>
  );
}

export function YourVisionBook() {
  return (
    <section data-testid="vbw-your-vision-book-section" className="relative overflow-hidden bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-[82px] md:pt-[97px] pb-[28px] md:pb-[36px] reveal">
        <div className="max-w-2xl">
          <p className="text-xs tracking-[0.24em] uppercase text-[#159E9A] mb-5">
            Your Vision Book
          </p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-[54px] leading-[1.1] tracking-tight text-[#1C1917] max-w-xl">
            Every page becomes a conversation with yourself.
          </h2>
        </div>

        {/* WeightTransformation — the dominant image of the sequence,
            anchoring the section right after the headline. Native 4:3
            aspect ratio, zero hard crop. */}
        <div className="mt-[32px] md:mt-[40px]">
          <SpreadImage
            src={WEIGHT_IMG}
            alt={WEIGHT_ALT}
            testId="vbw-weighttransformation-image"
            aspect="4 / 3"
            className="w-full md:w-[75%] mx-auto"
          />
        </div>

        <div className="w-full md:w-[75%] md:mx-auto mt-[32px] md:mt-[40px] space-y-1 md:text-right">
          <p className="font-display text-2xl md:text-3xl text-[#57534E] leading-snug">
            A Vision Book doesn&rsquo;t tell you who to become.
          </p>
          <p className="font-display text-2xl md:text-3xl text-[#159E9A] leading-snug">
            It helps you recognize the person you&rsquo;ve been becoming all
            along.
          </p>
        </div>
      </div>
    </section>
  );
}
